import { render, staticRenderFns } from "./GetToken.vue?vue&type=template&id=09f6b16c&scoped=true&"
import script from "./GetToken.vue?vue&type=script&lang=js&"
export * from "./GetToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6b16c",
  null
  
)

export default component.exports